import React from "react";

export default function BookingCancel({ onNavigate }) {
  return (
    <div style={page}>
      <div style={panel}>
        <div style={topRow}>
          <div style={{ ...iconCircle, ...iconNeutral }}>×</div>

          <div style={{ display: "grid", gap: 4 }}>
            <div style={kicker}>Jampot Rally 2026</div>
            <h1 style={title}>Payment cancelled</h1>
          </div>
        </div>

        <div style={{ marginTop: 14 }}>
          <p style={bodyText}>
            Your payment was cancelled and <b>no charge was made</b>.
          </p>

          <div style={infoBox}>
            <div style={{ fontWeight: 800, marginBottom: 6 }}>Good to know</div>
            <ul style={list}>
              <li>Your booking wasn’t confirmed.</li>
              <li>If you selected rooms, they’ll be held briefly then released.</li>
              <li>Online bookings are now closed because the rally is underway.</li>
            </ul>
          </div>

          <div style={btnRow}>
            <button style={btnPrimary} onClick={() => onNavigate("jampot")}>
              Rally info
            </button>
            <button style={btnGhost} onClick={() => onNavigate("home")}>
              Back to site
            </button>
          </div>
        </div>

        <div style={footer}>
          <span style={footerChip}>No payment taken</span>
          <span style={footerChip}>Rooms auto-released if unpaid</span>
        </div>
      </div>
    </div>
  );
}

/* ---------- styles ---------- */

const page = {
  minHeight: "70vh",
  display: "grid",
  placeItems: "center",
  padding: 20,
  background: "linear-gradient(180deg, #f6f3ee 0%, #ffffff 60%)",
};

const panel = {
  width: "min(760px, 100%)",
  borderRadius: 18,
  border: "1px solid rgba(0,0,0,0.10)",
  background: "white",
  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  padding: 18,
};

const topRow = {
  display: "flex",
  gap: 14,
  alignItems: "center",
  padding: 14,
  borderRadius: 14,
  background:
    "linear-gradient(90deg, rgba(210,194,166,0.45), rgba(225,214,193,0.35))",
  border: "1px solid rgba(0,0,0,0.06)",
};

const iconCircle = {
  width: 44,
  height: 44,
  borderRadius: 999,
  display: "grid",
  placeItems: "center",
  fontWeight: 900,
  fontSize: 22,
  border: "1px solid rgba(0,0,0,0.12)",
  userSelect: "none",
};

const iconNeutral = {
  background: "rgba(0,0,0,0.06)",
};

const kicker = {
  fontSize: 12,
  letterSpacing: "0.08em",
  fontWeight: 800,
  opacity: 0.8,
};

const title = {
  margin: 0,
  fontSize: 26,
  lineHeight: 1.1,
};

const bodyText = {
  margin: "10px 0",
  fontSize: 15,
  lineHeight: 1.5,
  opacity: 0.95,
};

const infoBox = {
  marginTop: 12,
  padding: 14,
  borderRadius: 14,
  border: "1px solid rgba(0,0,0,0.08)",
  background: "rgba(0,0,0,0.03)",
};

const list = {
  margin: "8px 0 0",
  paddingLeft: 18,
  display: "grid",
  gap: 6,
};

const btnRow = {
  display: "flex",
  gap: 10,
  flexWrap: "wrap",
  marginTop: 16,
};

const btnBase = {
  padding: "10px 14px",
  borderRadius: 12,
  border: "1px solid rgba(0,0,0,0.18)",
  cursor: "pointer",
  fontWeight: 800,
};

const btnPrimary = {
  ...btnBase,
  background: "linear-gradient(90deg, #1F3A2E, #2a4b3b)",
  color: "white",
  border: "1px solid rgba(0,0,0,0.25)",
};

const btnGhost = {
  ...btnBase,
  background: "white",
};

const footer = {
  display: "flex",
  gap: 8,
  flexWrap: "wrap",
  marginTop: 16,
  paddingTop: 14,
  borderTop: "1px solid rgba(0,0,0,0.08)",
};

const footerChip = {
  fontSize: 12,
  opacity: 0.8,
  border: "1px solid rgba(0,0,0,0.10)",
  borderRadius: 999,
  padding: "5px 10px",
  background: "rgba(0,0,0,0.03)",
};
